import React, { useState, useEffect } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import {  useParams } from "react-router-dom";
// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";


//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	FormHelperText,
	NativeSelect,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	// Grid,
	// Select,
	Input,
	InputLabel,
	// MenuItem,
	Modal,
	Backdrop,
	//Fade,
	fade,
	Button,
	Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone, FaceRounded } from "@material-ui/icons";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	textField: {
        marginTop: '-15px',
	},
	whiteContainer : {
		background: 'rgba(255, 255, 255, 0.9)',
		padding: '1em',
		marginBottom: '1.5em',
		borderRadius: '0.75em',
	}
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const CustomerDetails = () => {
	const [dataLoaded, setDataLoaded] = useState(false);
	const [custDetails, setCustDetails] = useState();
	const classes = useStyles();
	const { id } = useParams();

	// Data Fetching
	useEffect(() => {
		data(); 
	}, []);

	const data = async () => {
		//get data from api (for table)
		setDataLoaded(false);
		if(id !== ''){
			await axios.get(process.env.REACT_APP_API_URL+'get_single_entity_data', {
				params:{
					idno: id,
				}
			}).then((result)=>{
				setCustDetails(result.data.data);
				setDataLoaded(true);
			}).catch((error)=>{
				// console.log(error.message);
			})
		}
	};

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);
	// const toggle = () => setOpen(!open);

	// const handleModalOpen = () => {
	// 	setModalOpen(true);
	// };

	// const handleModalClose = () => {
	// 	setModalOpen(false);
	// };
	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AccountBalanceIcon />
				</div>
				<NavLink to={"/entity"}><h2 style={{color:"black"}}>Entity</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<NavLink to={"/entity/customer-info"}><h2 style={{color:"black"}}>Customer Information</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>Customer Details</h2>
			</div>
			<div className="page-container">
				{!dataLoaded ? (
					// <Preloader />
					<div>
					</div>
				) : (
		<div>		
		<Grid className={classes.whiteContainer} container spacing={2}>
			<Grid item xs={12} sm={12}>
				<h4 className={classes.title}>Account Information</h4>
			</Grid>
			<Grid item xs={12} sm={3} md={3} lg={3} xl={2}>
              <TextField
                variant="outlined"
				value={custDetails.idno || ' '}
                fullWidth={true}
                id="idno"
                label="ID No."
				name="idno"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
			<Grid item xs={12} sm={3} md={3} lg={3} xl={2}>
              <TextField
                variant="outlined"
				value={custDetails.cardno || ' '}
                fullWidth={true}
                id="idno"
                label="Card No."
				name="cardno"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
			<Grid item xs={12} sm={3} md={3} lg={3} xl={2}>
              <TextField
                variant="outlined"
				value={custDetails.tagtype || ' '}
                fullWidth={true}
                id="tagtype"
                label="Tag Type"
				name="tagtype"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
			<Grid item xs={12} sm={3} md={3} lg={3} xl={2}>
              <TextField
                variant="outlined"
				
				value={custDetails.regdate || ' '}
                fullWidth
                id="registration"
                label="Registration"
				name="registration"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
			<Grid item xs={12} sm={4}>
              <TextField
                variant="outlined"
				
				value={custDetails.team_name || ' '}
                fullWidth
                id="team"
                label="Team"
				name="team"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
			<Grid item xs={12} sm={8}>
              <TextField
                variant="outlined"
				
				value={custDetails.account_type || ' '}
                fullWidth
                id="accountType"
                label="Account Type"
				name="accountType"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
			<Grid item xs={12} sm={12}>
              <TextField
                variant="outlined"
				
				value={custDetails.sponsor || ' '}
                fullWidth
                id="sponsor"
                label="Sponsor"
				name="sponsor"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
			<Grid item xs={12} sm={12}>
              <TextField
                variant="outlined"
                
				fullWidth
				value={custDetails.placement || ' '}
                id="placement"
                label="Placement"
				name="placement"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>	
			<Grid item xs={12} sm={12}>
              <TextField
                variant="outlined"
				
				value={custDetails.pricecat_desc || ' '}
                fullWidth
                id="pricecat_desc"
                label="Pricecat"
				name="pricecat_desc"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
		</Grid>		  

		<Grid className={classes.whiteContainer} container spacing={2}>		  
			<Grid item xs={12} sm={12}>
				<h4 className={classes.title}>Personal Information</h4>		
			</Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                name="firstName"
                variant="outlined"
				
				value={custDetails.fname || ' '}
				fullWidth
                id="firstName"
				label="First Name"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                variant="outlined"
				
				value={custDetails.mname || ' '}
                fullWidth
                id="middleName"
                label="Middle Name"
				name="middleName"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
			<Grid item xs={12} sm={4}>
              <TextField
                variant="outlined"
				
				value={custDetails.lname || ' '}
                fullWidth
                id="lastName"
                label="Last Name"
				name="lastName"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
			<Grid item xs={12} sm={4}>
              <TextField
                name="birthday"
                variant="outlined"
				
				value={custDetails.bday || ' '}
				fullWidth
                id="birthday"
				label="Birthday"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                variant="outlined"
				
				value={custDetails.conno || ' '}
                fullWidth
                id="contactNo"
                label="Contact Number"
				name="contactNo"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
			<Grid item xs={12} sm={4}>
              <TextField
                variant="outlined"
				
				value={custDetails.email || ' '}
                fullWidth
                id="email"
                label="Email"
				name="email"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
				
				value={custDetails.address || ' '}
                fullWidth
                id="address"
                label="Address"
				name="address"
				InputProps={{
					readOnly: true,
				  }}
              />
            </Grid>
		  </Grid>	
		  </div>
				)}
			</div>
		</div>
	);
};

export default CustomerDetails;
